import { render, staticRenderFns } from "./AnnouncementFull.vue?vue&type=template&id=10adcbc2&scoped=true"
import script from "./AnnouncementFull.vue?vue&type=script&lang=js"
export * from "./AnnouncementFull.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementFull.vue?vue&type=style&index=0&id=10adcbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10adcbc2",
  null
  
)

export default component.exports